import React from 'react';
import { PortalAuthProvider } from '../../contexts/PortalAuthContext';

/**
 * Wraps any portal route in the PortalAuthProvider.
 * Keeps the marketing Router cleanly separated from auth state.
 */
export default function PortalShell({ children }) {
  return <PortalAuthProvider>{children}</PortalAuthProvider>;
}
